import React from 'react';

import Container from '../../atoms/Container';
import Footer from '../../molecules/Footer';
import Navbar from '../../molecules/Navbar';
import Card from '../../organisms/Card';

const GoToBackLogin: React.FC = () => {
  return (
    <Container>
      <Navbar />
      <Card />
      <Footer />
    </Container>
  );
};

export default GoToBackLogin;
